
import { get, put, post } from '@api/request';

export async function fetchWaitingRooms(
  { appealsService },
  authenticationToken,
  { docketGroup }
) {
  if (docketGroup === '$!all!$') {
    var url = `${appealsService}/prodigyappeals/waitingroom`;
  } else {
    url = `${appealsService}/prodigyappeals/waitingroom?docketGroup=${docketGroup}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchWaitingRoomsInformal(
  { appealsService },
  authenticationToken,
  { docketGroup }
) {
  if (docketGroup === '$!all!$') {
    var url = `${appealsService}/prodigyappeals/waitingroom/informal`;
  } else {
    url = `${appealsService}/prodigyappeals/waitingroom/informal?docketGroup=${docketGroup}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchDocketGroupCodes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/codes?type=Appeals&name=Docket Group`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function moveCheckInItem(
  { appealsService },
  authenticationToken,
  { checkInID, payload }
) {
  const url = `${appealsService}/prodigyappeals/waitingroom/${checkInID}/move`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function moveCheckInItemInformal(
  { appealsService },
  authenticationToken,
  { checkInID, payload }
) {
  const url = `${appealsService}/prodigyappeals/waitingroom/informal/${checkInID}/move`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}


export async function assignDirectly(
  { appealsService },
  authenticationToken,
  { panelID, payload }
) {
  const url = `${appealsService}/prodigyappeals/waitingroom/panel/${panelID}/assigndirectly`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function assignDirectlyInformal(
  { appealsService },
  authenticationToken,
  { panelID, payload }
) {
  const url = `${appealsService}/prodigyappeals/waitingroom/informal/panel/${panelID}/assigndirectly`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchWaitingRoomByAppraiser(
  { appealsService },
  authenticationToken
) {
  const url = `${appealsService}/prodigyappeals/waitingroom/fetchbyappraiser`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppraiserOverview(
  { appealsService },
  authenticationToken
) {
  const url = `${appealsService}/prodigyappeals/appraiseroverview`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAgentDocketGroups(
  { appealsService },
  authenticationToken
) {
  const url = `${appealsService}/prodigyappeals/agentdocketgroupwaitingroom`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function moveAgentDocketGroupCheckInItem(
  { appealsService },
  authenticationToken,
  { checkInID, payload }
) {
  const url = `${appealsService}/prodigyappeals/agentdocketgroupwaitingroom/${checkInID}/move`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function assignAgentDocketGroupDirectly(
  { appealsService },
  authenticationToken,
  { panelID, payload }
) {
  const url = `${appealsService}/prodigyappeals/agentdocketgroupwaitingroom/panel/${panelID}/assigndirectly`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchAppealMeetingLink(
  { appealsService },
  authenticationToken,
  { appealID, meetingType }
) {
  const url = `${appealsService}/conference/appeal/${appealID}/link?meetingType=${meetingType}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function sortAllRoomRecords(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/conference/waitingroom/sortallrooms`;
  const { body } = await post(authenticationToken, url);
  return body;
}
